/** Saved/API values may be string or number; UI uses 0 | 1 | 2. */
export function normalizeBusinessErrorState(value: unknown): 0 | 1 | 2 {
  const n = Number(value);
  if (n === 0 || n === 1 || n === 2) {
    return n;
  }
  return 2;
}

export const validateConfig = (config) => {
  try {
    if (config.name === '' || config.rules.some((r) => r.value === '')) {
      return false;
    }
  } catch (err) {
    return false;
  }
  return true;
};
